import { use } from 'react';

import { AdminAuthContext } from './AdminAuthContext';

export function useAdminAuth() {
  const value = use(AdminAuthContext);
  if (!value) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return value;
}
